import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Chart from 'chart.js/auto';
import logo from '../components/assets/image/LOGO_FCN.png';

// ✅ EXPORTAR Junta Directiva
export const exportJuntaDirectivaPDF = (asociacion, representantes, departamentos, municipios) => {
  try {
    const doc = new jsPDF(PDF_CONFIG.orientation, PDF_CONFIG.unit, PDF_CONFIG.format);

    doc.setProperties({
      title: `Junta Directiva: ${asociacion.nombre_abreviado}`,
      author: 'Fondo Cafetero Nacional',
      creator: 'Sistema de Gestión de Asociaciones'
    });

    addCoverPage(doc, `Junta Directiva - ${asociacion.nombre_abreviado}`, 'Organización y Estructura Directiva');

    const startY = addPDFHeader(doc, `Junta Directiva - ${asociacion.nombre_abreviado}`, 'Estructura Organizacional');

    const juntaDirectiva = representantes.filter(rep =>
      rep.categorias?.some(cat => cat.Id === 4 && cat.Estado !== 'Inactivo')
    );

    const primaryColor = hexToRgb(PDF_CONFIG.colors.primary);
    const cardBg = hexToRgb(PDF_CONFIG.colors.cardBg);
    const textLight = hexToRgb(PDF_CONFIG.colors.textLight);

    if (juntaDirectiva.length === 0) {
      addModernShadow(doc, PDF_CONFIG.margins.left, startY + 20, 170, 35, PDF_CONFIG.colors.cardBg);
      
      doc.setFont('Helvetica', 'bold');
      doc.setFontSize(11);
      doc.setTextColor(textLight.r, textLight.g, textLight.b);
      doc.text('Sin Registros', PDF_CONFIG.margins.left + 85, startY + 35, { align: 'center' });
      
      doc.setFont('Helvetica', 'normal');
      doc.setFontSize(9);
      doc.text('No hay miembros registrados en la Junta Directiva', PDF_CONFIG.margins.left + 85, startY + 42, { align: 'center' });
    } else {
      const juntaOrdenada = ordenarJuntaDirectivaPorJerarquia(juntaDirectiva);



      const tableData = juntaOrdenada.map(rep => {
        const categoriaJunta = rep.categorias?.find(cat => cat.Id === 4 && cat.Estado !== 'Inactivo');
        const departamento = departamentos?.find(d => d.CodigoDepartamento === rep.cod_depto);
        const municipio = municipios?.find(m => String(m.CodigoMunicipio).trim() === String(rep.cod_municipio).trim());

        return [
          rep.nombre_representante || 'Sin nombre',
          categoriaJunta?.Cargo || 'Miembro',
          rep.dni || 'Sin DNI',
          departamento?.NombreDepartamento || 'N/A',
          municipio?.NombreMunicipio || 'N/A'
        ];
      });

      doc.autoTable({
        head: [['Nombre Completo', 'Cargo', 'DNI', 'Departamento', 'Municipio']],
        body: tableData,
        startY: startY + 32,
        styles: {
          font: 'Helvetica',
          fontSize: 9.5,
          cellPadding: 5.5,
          textColor: [26, 26, 26],
          halign: 'left',
          lineColor: [232, 223, 214],
          lineWidth: 0.2
        },
        headStyles: {
          fillColor: [primaryColor.r, primaryColor.g, primaryColor.b],
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          halign: 'left',
          fontSize: 10
        },
        alternateRowStyles: {
          fillColor: [cardBg.r, cardBg.g, cardBg.b]
        },
        margin: {
          left: PDF_CONFIG.margins.left,
          right: PDF_CONFIG.margins.right
        },
        columnStyles: {
          0: { cellWidth: 'auto', fontStyle: 'bold' },
          1: { cellWidth: 'auto', textColor: [107, 68, 35], fontStyle: 'bold' },
          2: { cellWidth: 25 },
          3: { cellWidth: 'auto' },
          4: { cellWidth: 'auto' }
        }
      });
    }

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addPDFFooter(doc);
    }

    doc.save(`Junta_Directiva_${asociacion.nombre_abreviado}_${new Date().toISOString().split('T')[0]}.pdf`);
  } catch (error) {
    console.error('Error en exportJuntaDirectivaPDF:', error);
    throw error;
  }
};

// ✅ EXPORTAR resumen estadístico
export const exportResumenEstadisticoPDF = (asociaciones, representantes, categorias, departamentos, municipios) => {
  try {
    const doc = new jsPDF(PDF_CONFIG.orientation, PDF_CONFIG.unit, PDF_CONFIG.format);

    doc.setProperties({
      title: 'Resumen Estadístico de Representantes',
      author: 'Fondo Cafetero Nacional',
      creator: 'Sistema de Gestión de Asociaciones'
    });

    addCoverPage(doc, 'Resumen Estadístico', 'Análisis Completo de Representantes Gremiales');

    let currentY = addPDFHeader(doc, 'Resumen Estadístico', 'Dashboard Ejecutivo');

    const totalReps = representantes.length;
    const totalAsocs = asociaciones.length;
    const totalJunta = representantes.filter(rep => rep.categorias?.some(cat => cat.Id === 4 && cat.Estado !== 'Inactivo')).length;

    const primaryColor = hexToRgb(PDF_CONFIG.colors.primary);
    const secondaryColor = hexToRgb(PDF_CONFIG.colors.secondary);
    const accentColor = hexToRgb(PDF_CONFIG.colors.accent);
    const successColor = hexToRgb(PDF_CONFIG.colors.success);
    const infoColor = hexToRgb(PDF_CONFIG.colors.info);
    const cardBg = hexToRgb(PDF_CONFIG.colors.cardBg);

    addModernBadge(doc, PDF_CONFIG.margins.left, currentY + 5, 'Total', totalReps, PDF_CONFIG.colors.secondary, '●');
    addModernBadge(doc, PDF_CONFIG.margins.left + 47, currentY + 5, 'Asociaciones', totalAsocs, PDF_CONFIG.colors.info, '■');
    addModernBadge(doc, PDF_CONFIG.margins.left + 94, currentY + 5, 'Junta Dir.', totalJunta, PDF_CONFIG.colors.success, '★');
    addModernBadge(doc, PDF_CONFIG.margins.left + 141, currentY + 5, 'Promedio', Math.round(totalReps / totalAsocs), PDF_CONFIG.colors.accent, '▲');

    currentY += 35;

    currentY = addSectionTitle(doc, currentY, '📊  Resumen por Asociaciones', totalAsocs);

    const resumenAsociaciones = asociaciones.map(asoc => {
      const repsAsoc = representantes.filter(rep => rep.cod_asociacion === asoc.cod_asociacion);
      return [
        asoc.nombre_abreviado,
        repsAsoc.length.toString(),
        repsAsoc.filter(rep => rep.categorias?.some(cat => cat.Id === 4 && cat.Estado !== 'Inactivo')).length.toString()
      ];
    });

    doc.autoTable({
      head: [['Asociación', 'Total Representantes', 'Junta Directiva']],
      body: resumenAsociaciones,
      startY: currentY,
      styles: {
        font: 'Helvetica',
        fontSize: 9.5,
        cellPadding: 5,
        textColor: [26, 26, 26],
        halign: 'left',
        lineColor: [232, 223, 214],
        lineWidth: 0.2
      },
      headStyles: {
        fillColor: [secondaryColor.r, secondaryColor.g, secondaryColor.b],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        halign: 'left',
        fontSize: 10
      },
      alternateRowStyles: {
        fillColor: [cardBg.r, cardBg.g, cardBg.b]
      },
      margin: {
        left: PDF_CONFIG.margins.left,
        right: PDF_CONFIG.margins.right
      },
      columnStyles: {
        0: { cellWidth: 'auto', fontStyle: 'bold' },
        1: { cellWidth: 50, halign: 'center', textColor: [secondaryColor.r, secondaryColor.g, secondaryColor.b], fontStyle: 'bold' },
        2: { cellWidth: 45, halign: 'center', textColor: [successColor.r, successColor.g, successColor.b], fontStyle: 'bold' }
      }
    });

    currentY = doc.lastAutoTable.finalY + 20;

    if (asociaciones.length > 0 && currentY < 190) {
      const canvas = document.createElement('canvas');
      canvas.width = 700;
      canvas.height = 280;
      const ctx = canvas.getContext('2d');

      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: asociaciones.map(asoc => asoc.nombre_abreviado),
          datasets: [{
            label: 'Representantes',
            data: asociaciones.map(asoc =>
              representantes.filter(rep => rep.cod_asociacion === asoc.cod_asociacion).length
            ),
            backgroundColor: 'rgba(107, 68, 35, 0.85)',
            borderColor: 'rgba(107, 68, 35, 1)',
            borderWidth: 2,
            borderRadius: 8,
            borderSkipped: false
          }]
        },
        options: {
          responsive: true,
          plugins: {
            legend: { display: false },
            title: {
              display: true,
              text: 'Distribución de Representantes por Asociación',
              font: { size: 18, weight: 'bold', family: 'Helvetica' },
              color: '#2C1810',
              padding: { top: 10, bottom: 20 }
            }
          },
          scales: {
            y: {
              beginAtZero: true,
              ticks: { 
                color: '#5a5a5a',
                font: { size: 11, family: 'Helvetica' }
              },
              grid: { color: 'rgba(0, 0, 0, 0.06)' }
            },
            x: {
              ticks: { 
                color: '#5a5a5a',
                font: { size: 10, family: 'Helvetica', weight: 'bold' }
              },
              grid: { display: false }
            }
          }
        }
      });

      const imgData = canvas.toDataURL('image/png');
      
      if (currentY > 170) {
        doc.addPage();
        currentY = addPDFHeader(doc, 'Resumen Estadístico', 'Dashboard Ejecutivo');
      }

      currentY = addSectionTitle(doc, currentY, '📈  Análisis Gráfico', null);
      
      addModernShadow(doc, PDF_CONFIG.margins.left, currentY, 170, 75, '#FFFFFF');
      doc.addImage(imgData, 'PNG', PDF_CONFIG.margins.left + 2, currentY + 2, 166, 71);
      currentY += 85;
    }

    

    currentY = addSectionTitle(doc, currentY, '🏷️  Resumen por Categorías', categorias.length);

    const resumenCategorias = categorias.map(cat => {
      const repsCat = representantes.filter(rep =>
        rep.categorias?.some(categoria => categoria.Id === cat.Id && categoria.Estado !== 'Inactivo')
      );
      const porcentaje = totalReps > 0 ? ((repsCat.length / totalReps) * 100).toFixed(1) : '0.0';
      return [
        cat.Descripcion,
        repsCat.length.toString(),
        `${porcentaje}`
      ];
    }).filter(item => parseInt(item[1]) > 0);

    doc.autoTable({
      head: [['Categoría', 'Total', '% del Total']],
      body: resumenCategorias,
      startY: currentY,
      styles: {
        font: 'Helvetica',
        fontSize: 9.5,
        cellPadding: 5,
        textColor: [26, 26, 26],
        halign: 'left',
        lineColor: [232, 223, 214],
        lineWidth: 0.2
      },
      headStyles: {
        fillColor: [accentColor.r, accentColor.g, accentColor.b],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        halign: 'left',
        fontSize: 10
      },
      alternateRowStyles: {
        fillColor: [cardBg.r, cardBg.g, cardBg.b]
      },
      margin: {
        left: PDF_CONFIG.margins.left,
        right: PDF_CONFIG.margins.right
      },
      columnStyles: {
        0: { cellWidth: 'auto', fontStyle: 'bold' },
        1: { cellWidth: 40, halign: 'center', textColor: [accentColor.r, accentColor.g, accentColor.b], fontStyle: 'bold' },
        2: { cellWidth: 35, halign: 'center', textColor: [infoColor.r, infoColor.g, infoColor.b] }
      }
    });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addPDFFooter(doc);
    }

    doc.save(`Resumen_Estadistico_${new Date().toISOString().split('T')[0]}.pdf`);
  } catch (error) {
    console.error('Error en exportResumenEstadisticoPDF:', error);
    throw error;
  }
};


// Configuración mejorada del PDF con paleta profesional
const PDF_CONFIG = {
  format: 'a4',
  orientation: 'portrait',
  unit: 'mm',
  margins: {
    top: 45,
    left: 20,
    right: 20,
    bottom: 25
  },
  colors: {
    primary: '#2C1810',
    secondary: '#6B4423',
    accent: '#8B5A3C',
    tertiary: '#A0724E',
    gold: '#C9A56D',
    text: '#1a1a1a',
    textLight: '#5a5a5a',
    textMuted: '#8a8a8a',
    background: '#FFFFFF',
    cardBg: '#F9F7F4',
    cardBorder: '#E8DFD6',
    highlight: '#FFF8F0',
    success: '#2D5F3F',
    info: '#3B5F7F',
    warning: '#8B6914'
  },
  fonts: {
    title: { size: 26, style: 'bold', spacing: 0.5 },
    subtitle: { size: 16, style: 'normal', spacing: 0.3 },
    heading: { size: 18, style: 'bold', spacing: 0.4 },
    subheading: { size: 13, style: 'bold', spacing: 0.2 },
    body: { size: 10, style: 'normal', spacing: 0.1 },
    small: { size: 8, style: 'normal', spacing: 0 },
    caption: { size: 9, style: 'italic', spacing: 0 }
  }
};

// Helper: Convertir hex a RGB
const hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : { r: 0, g: 0, b: 0 };
};

// Helper: Sombra moderna con degradado sutil
const addModernShadow = (doc, x, y, width, height, color = PDF_CONFIG.colors.cardBg) => {
  const shadowColor = hexToRgb('#D0D0D0');
  doc.setFillColor(shadowColor.r, shadowColor.g, shadowColor.b);
  doc.setGState(new doc.GState({ opacity: 0.15 }));
  doc.roundedRect(x + 0.8, y + 0.8, width, height, 3, 3, 'F');
  doc.setGState(new doc.GState({ opacity: 1 }));
  
  const bgColor = hexToRgb(color);
  doc.setFillColor(bgColor.r, bgColor.g, bgColor.b);
  doc.roundedRect(x, y, width, height, 3, 3, 'F');
  
  const borderColor = hexToRgb(PDF_CONFIG.colors.cardBorder);
  doc.setDrawColor(borderColor.r, borderColor.g, borderColor.b);
  doc.setLineWidth(0.3);
  doc.roundedRect(x, y, width, height, 3, 3, 'S');
};

// Helper: Línea decorativa
const addDecorativeLine = (doc, x1, y, x2, color = PDF_CONFIG.colors.accent, thickness = 1) => {
  const lineColor = hexToRgb(color);
  doc.setDrawColor(lineColor.r, lineColor.g, lineColor.b);
  doc.setLineWidth(thickness);
  doc.line(x1, y, x2, y);
};

// Helper: Badge moderno
const addModernBadge = (doc, x, y, label, value, color = PDF_CONFIG.colors.secondary, icon = '●') => {
  const badgeWidth = 42;
  const badgeHeight = 20;
  
  const bgColor = hexToRgb(color);
  doc.setFillColor(bgColor.r, bgColor.g, bgColor.b);
  doc.roundedRect(x, y, badgeWidth, badgeHeight, 4, 4, 'F');
  
  const highlightColor = hexToRgb(PDF_CONFIG.colors.gold);
  doc.setFillColor(highlightColor.r, highlightColor.g, highlightColor.b);
  doc.setGState(new doc.GState({ opacity: 0.2 }));
  doc.roundedRect(x, y, badgeWidth, badgeHeight / 3, 4, 4, 'F');
  doc.setGState(new doc.GState({ opacity: 1 }));
  
  doc.setFont('Helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(255, 255, 255);
  doc.text(icon, x + 3, y + 7);
  
  doc.setFontSize(7);
  doc.setFont('Helvetica', 'normal');
  doc.text(label.toUpperCase(), x + badgeWidth / 2, y + 7, { align: 'center' });
  
  doc.setFontSize(13);
  doc.setFont('Helvetica', 'bold');
  doc.text(String(value), x + badgeWidth / 2, y + 15, { align: 'center' });
};

// Función mejorada para ordenar Junta Directiva
const ordenarJuntaDirectivaPorJerarquia = (representantes) => {
  const ordenJerarquia = {
    'presidente': 1, 'vicepresidente': 2, 'secretario': 3,
    'pro-secretario': 4, 'tesorero': 5, 'vocal': 6,
    'fiscal': 7, 'suplente': 8
  };

  const romanToInt = (roman) => {
    const romanNumerals = {
      'I': 1, 'II': 2, 'III': 3, 'IV': 4, 'V': 5,
      'VI': 6, 'VII': 7, 'VIII': 8, 'IX': 9, 'X': 10,
      'XI': 11, 'XII': 12, 'XIII': 13, 'XIV': 14, 'XV': 15
    };
    return romanNumerals[roman] || 999;
  };

  const extraerNumeroRomano = (cargo) => {
    if (!cargo) return '';
    const match = cargo.toUpperCase().match(/(VOCAL|SUPLENTE)\s+([IVX]+)/);
    return match ? match[2].trim() : '';
  };

  return [...representantes].sort((a, b) => {
    const cargoA = a.categorias?.find(cat => cat.Id === 4 && cat.Estado !== 'Inactivo')?.Cargo?.toLowerCase() || '';
    const cargoB = b.categorias?.find(cat => cat.Id === 4 && cat.Estado !== 'Inactivo')?.Cargo?.toLowerCase() || '';

    const obtenerTipoCargo = (cargo) => {
      const cargoLimpio = cargo.trim().toLowerCase();
      if (cargoLimpio === 'presidente') return 'presidente';
      if (cargoLimpio === 'vicepresidente') return 'vicepresidente';
      if (cargoLimpio === 'secretario') return 'secretario';
      if (cargoLimpio === 'pro-secretario') return 'pro-secretario';
      if (cargoLimpio === 'tesorero') return 'tesorero';
      if (cargoLimpio === 'fiscal') return 'fiscal';
      if (cargoLimpio.startsWith('vocal ')) return 'vocal';
      if (cargoLimpio.startsWith('suplente ')) return 'suplente';
      return 'otro';
    };

    const tipoCargoA = obtenerTipoCargo(cargoA);
    const tipoCargoB = obtenerTipoCargo(cargoB);
    const jerarquiaA = ordenJerarquia[tipoCargoA] || 99;
    const jerarquiaB = ordenJerarquia[tipoCargoB] || 99;

    if (jerarquiaA === jerarquiaB && (tipoCargoA === 'vocal' || tipoCargoA === 'suplente')) {
      const numeroA = romanToInt(extraerNumeroRomano(cargoA));
      const numeroB = romanToInt(extraerNumeroRomano(cargoB));
      return numeroA - numeroB;
    }

    return jerarquiaA - jerarquiaB;
  });
};

// ✨ PORTADA PREMIUM - Diseño limpio y formal
const addCoverPage = (doc, title, subtitle) => {
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, pageWidth, pageHeight, 'F');

  const primaryColor = hexToRgb(PDF_CONFIG.colors.primary);
  const accentColor = hexToRgb(PDF_CONFIG.colors.accent);
  
  doc.setFillColor(primaryColor.r, primaryColor.g, primaryColor.b);
  doc.rect(0, 0, pageWidth, 8, 'F');
  
  doc.setFillColor(accentColor.r, accentColor.g, accentColor.b);
  doc.setGState(new doc.GState({ opacity: 0.5 }));
  doc.rect(0, 5, pageWidth, 3, 'F');
  doc.setGState(new doc.GState({ opacity: 1 }));

  const logoSize = 55;
  const logoX = pageWidth / 2 - logoSize / 2;
  const logoY = 55;
  
  doc.addImage(logo, 'PNG', logoX, logoY, logoSize, logoSize);

  doc.setFont('Helvetica', 'bold');
  doc.setFontSize(22);
  doc.setTextColor(primaryColor.r, primaryColor.g, primaryColor.b);
  doc.text('FONDO CAFETERO NACIONAL', pageWidth / 2, 135, { align: 'center' });

  addDecorativeLine(doc, pageWidth / 2 - 40, 140, pageWidth / 2 + 40, PDF_CONFIG.colors.gold, 1.5);

  doc.setFontSize(17);
  const secondaryColor = hexToRgb(PDF_CONFIG.colors.secondary);
  doc.setTextColor(secondaryColor.r, secondaryColor.g, secondaryColor.b);
  doc.text(title, pageWidth / 2, 152, { align: 'center' });

  doc.setFont('Helvetica', 'normal');
  doc.setFontSize(11);
  const textLightColor = hexToRgb(PDF_CONFIG.colors.textLight);
  doc.setTextColor(textLightColor.r, textLightColor.g, textLightColor.b);
  doc.text(subtitle, pageWidth / 2, 163, { align: 'center' });

  const dateY = 190;
  

  
  doc.setFont('Helvetica', 'normal');
  doc.setFontSize(11);
  doc.setTextColor(primaryColor.r, primaryColor.g, primaryColor.b);
  const fecha = new Date().toLocaleDateString('es-ES', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  doc.text(fecha.charAt(0).toUpperCase() + fecha.slice(1), pageWidth / 2, dateY + 9, { align: 'center' });

  doc.setFont('Helvetica', 'normal');
  doc.setFontSize(8);
  const mutedColor = hexToRgb(PDF_CONFIG.colors.textMuted);
  doc.setTextColor(mutedColor.r, mutedColor.g, mutedColor.b);
  doc.text('Sistema Acreditaciones Gremiales', pageWidth / 2, pageHeight - 15, { align: 'center' });

  doc.addPage();
};

// ✨ ENCABEZADO MODERNO
const addPDFHeader = (doc, title, subtitle = '') => {
  const pageWidth = doc.internal.pageSize.width;
  const primaryColor = hexToRgb(PDF_CONFIG.colors.primary);
  const accentColor = hexToRgb(PDF_CONFIG.colors.accent);

  const headerBg = hexToRgb(PDF_CONFIG.colors.cardBg);
  doc.setFillColor(headerBg.r, headerBg.g, headerBg.b);
  doc.rect(0, 0, pageWidth, 35, 'F');
  
  doc.setFillColor(primaryColor.r, primaryColor.g, primaryColor.b);
  doc.rect(0, 35, pageWidth, 2, 'F');
  
  const goldColor = hexToRgb(PDF_CONFIG.colors.gold);
  doc.setFillColor(goldColor.r, goldColor.g, goldColor.b);
  doc.setGState(new doc.GState({ opacity: 0.6 }));
  doc.rect(0, 34, pageWidth, 1, 'F');
  doc.setGState(new doc.GState({ opacity: 1 }));

  const logoSize = 22;
  doc.addImage(logo, 'PNG', PDF_CONFIG.margins.left, 7, logoSize, logoSize);

  addDecorativeLine(doc, PDF_CONFIG.margins.left + 28, 10, PDF_CONFIG.margins.left + 28, 
                     PDF_CONFIG.colors.accent, 0.5);
  doc.setDrawColor(goldColor.r, goldColor.g, goldColor.b);
  doc.setLineWidth(0.3);
  doc.line(PDF_CONFIG.margins.left + 28.5, 10, PDF_CONFIG.margins.left + 28.5, 27);

  doc.setFont('Helvetica', 'bold');
  doc.setFontSize(13);
  doc.setTextColor(primaryColor.r, primaryColor.g, primaryColor.b);
  doc.text(title, PDF_CONFIG.margins.left + 33, 16);



  
  doc.setFont('Helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(primaryColor.r, primaryColor.g, primaryColor.b);
  const fecha = new Date().toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
  doc.text(fecha.toUpperCase(), pageWidth - PDF_CONFIG.margins.right, 20, { align: 'right' });

  return 42;
};

// ✨ PIE DE PÁGINA ELEGANTE
const addPDFFooter = (doc) => {
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const primaryColor = hexToRgb(PDF_CONFIG.colors.primary);
  const textMuted = hexToRgb(PDF_CONFIG.colors.textMuted);

  addDecorativeLine(doc, PDF_CONFIG.margins.left, pageHeight - 20, 
                     pageWidth - PDF_CONFIG.margins.right, PDF_CONFIG.colors.gold, 0.8);
  
  doc.setDrawColor(primaryColor.r, primaryColor.g, primaryColor.b);
  doc.setLineWidth(0.3);
  doc.line(PDF_CONFIG.margins.left, pageHeight - 19.5, 
           pageWidth - PDF_CONFIG.margins.right, pageHeight - 19.5);

  doc.setFont('Helvetica', 'bold');
  doc.setFontSize(8);
  doc.setTextColor(primaryColor.r, primaryColor.g, primaryColor.b);
  doc.text('Fondo Cafetero Nacional', PDF_CONFIG.margins.left, pageHeight - 13);
  
  doc.setFont('Helvetica', 'normal');
  doc.setFontSize(7);
  doc.setTextColor(textMuted.r, textMuted.g, textMuted.b);
  doc.text('Sistema Acreditaciones Gremiales', PDF_CONFIG.margins.left, pageHeight - 9);

  const pageNum = doc.getCurrentPageInfo().pageNumber;
  const pageText = `${pageNum}`;
  
  doc.setFont('Helvetica', 'bold');
  doc.setFontSize(10);
  doc.setTextColor(primaryColor.r, primaryColor.g, primaryColor.b);
  doc.text(pageText, pageWidth - PDF_CONFIG.margins.right - 3, pageHeight - 11, { align: 'right' });
  
  doc.setFont('Helvetica', 'normal');
  doc.setFontSize(7);
  doc.setTextColor(textMuted.r, textMuted.g, textMuted.b);
  doc.text('Página', pageWidth - PDF_CONFIG.margins.right - 3, pageHeight - 15, { align: 'right' });
};

// ✨ TÍTULO DE SECCIÓN MODERNO
const addSectionTitle = (doc, y, title, count = null) => {
  const primaryColor = hexToRgb(PDF_CONFIG.colors.primary);
  const goldColor = hexToRgb(PDF_CONFIG.colors.gold);
  
  addModernShadow(doc, PDF_CONFIG.margins.left, y, 170, 13, PDF_CONFIG.colors.highlight);
  
  doc.setFillColor(goldColor.r, goldColor.g, goldColor.b);
  doc.roundedRect(PDF_CONFIG.margins.left, y, 3, 13, 1.5, 1.5, 'F');
  
  doc.setFont('Helvetica', 'bold');
  doc.setFontSize(12);
  doc.setTextColor(primaryColor.r, primaryColor.g, primaryColor.b);
  doc.text(title, PDF_CONFIG.margins.left + 7, y + 9);
  
  if (count !== null) {
    const countText = `${count} ${count === 1 ? 'registro' : 'registros'}`;
    doc.setFont('Helvetica', 'normal');
    doc.setFontSize(9);
    const accentColor = hexToRgb(PDF_CONFIG.colors.secondary);
    doc.setTextColor(accentColor.r, accentColor.g, accentColor.b);
    doc.text(countText, 185, y + 9, { align: 'right' });
  }
  
  return y + 18;
};

// ✅ EXPORTAR representantes de una categoría específica
export const exportCategoriaRepresentantesPDF = (categoria, representantes, asociaciones, departamentos, municipios) => {
  try {
    const doc = new jsPDF(PDF_CONFIG.orientation, PDF_CONFIG.unit, PDF_CONFIG.format);

    doc.setProperties({
      title: `Reporte de Categoría: ${categoria.Descripcion}`,
      author: 'Fondo Cafetero Nacional',
      creator: 'Sistema de Gestión de Asociaciones'
    });

    addCoverPage(doc, `Representantes - ${categoria.Descripcion}`, `Listado completo de ${representantes.length} representantes`);

    let currentY = addPDFHeader(doc, `Categoría: ${categoria.Descripcion}`, 'Listado de Representantes');

    addModernBadge(doc, PDF_CONFIG.margins.left, currentY + 5, 'Total', representantes.length, PDF_CONFIG.colors.secondary, '●');
    
    currentY += 32;

    const esDepartamental = categoria.Id === 3;

    const headers = esDepartamental 
      ? [['Nombre Completo', 'DNI', 'Asociación', 'Departamento', 'Municipio']]
      : [['Nombre Completo', 'DNI', 'Cargo', 'Asociación', 'Departamento', 'Municipio']];

    const tableData = representantes.map(rep => {
      const categoriaRep = rep.categorias?.find(cat => cat.Id === categoria.Id && cat.Estado !== 'Inactivo');
      const asociacion = asociaciones?.find(a => a.cod_asociacion === rep.cod_asociacion);
      const departamento = departamentos?.find(d => d.CodigoDepartamento === rep.cod_depto);
      const municipio = municipios?.find(m => String(m.CodigoMunicipio).trim() === String(rep.cod_municipio).trim());

      if (esDepartamental) {
        return [
          rep.nombre_representante || 'Sin nombre',
          rep.dni || 'Sin DNI',
          asociacion?.nombre_abreviado || 'N/A',
          departamento?.NombreDepartamento || 'N/A',
          municipio?.NombreMunicipio || 'N/A'
        ];
      }

      return [
        rep.nombre_representante || 'Sin nombre',
        rep.dni || 'Sin DNI',
        categoriaRep?.Cargo || 'Sin cargo',
        asociacion?.nombre_abreviado || 'N/A',
        departamento?.NombreDepartamento || 'N/A',
        municipio?.NombreMunicipio || 'N/A'
      ];
    });

    const primaryColor = hexToRgb(PDF_CONFIG.colors.primary);
    const cardBg = hexToRgb(PDF_CONFIG.colors.cardBg);

    const columnStyles = esDepartamental 
      ? {
          0: { cellWidth: 'auto', fontStyle: 'bold' },
          1: { cellWidth: 25 },
          2: { cellWidth: 'auto' },
          3: { cellWidth: 'auto' },
          4: { cellWidth: 'auto' }
        }
      : {
          0: { cellWidth: 'auto', fontStyle: 'bold' },
          1: { cellWidth: 25 },
          2: { cellWidth: 'auto' },
          3: { cellWidth: 'auto' },
          4: { cellWidth: 'auto' },
          5: { cellWidth: 'auto' }
        };

    doc.autoTable({
      head: headers,
      body: tableData,
      startY: currentY,
      styles: {
        font: 'Helvetica',
        fontSize: 9,
        cellPadding: 5,
        textColor: [26, 26, 26],
        halign: 'left',
        lineColor: [232, 223, 214],
        lineWidth: 0.2
      },
      headStyles: {
        fillColor: [primaryColor.r, primaryColor.g, primaryColor.b],
        textColor: [255, 255, 255],
        fontStyle: 'bold',
        halign: 'left',
        fontSize: 9.5
      },
      alternateRowStyles: {
        fillColor: [cardBg.r, cardBg.g, cardBg.b]
      },
      margin: {
        left: PDF_CONFIG.margins.left,
        right: PDF_CONFIG.margins.right
      },
      columnStyles: columnStyles,
      didDrawPage: () => addPDFFooter(doc)
    });

    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addPDFFooter(doc);
    }

    doc.save(`Representantes_${categoria.Descripcion}_${new Date().toISOString().split('T')[0]}.pdf`);
  } catch (error) {
    console.error('Error en exportCategoriaRepresentantesPDF:', error);
    throw error;
  }
};

// ✅ EXPORTAR todas las categorías de una asociación
export const exportAsociacionCategoriasPDF = (asociacion, categorias, representantes, departamentos, municipios) => {
  try {
    const doc = new jsPDF(PDF_CONFIG.orientation, PDF_CONFIG.unit, PDF_CONFIG.format);

    doc.setProperties({
      title: `Reporte Completo: ${asociacion.nombre_abreviado}`,
      author: 'Fondo Cafetero Nacional',
      creator: 'Sistema de Gestión de Asociaciones'
    });


    addCoverPage(doc, `Reporte de ${asociacion.nombre_abreviado}`, 'Acreditaciones Gremiales ');

    const primaryColor = hexToRgb(PDF_CONFIG.colors.primary);
    const accentColor = hexToRgb(PDF_CONFIG.colors.accent);
    const cardBg = hexToRgb(PDF_CONFIG.colors.cardBg);

    categorias.forEach((categoria, index) => {
      const repsCategoria = representantes.filter(rep =>
        rep.categorias?.some(cat => cat.Id === categoria.Id && cat.Estado !== 'Inactivo')
      );

      if (repsCategoria.length === 0) return;

      const repsOrdenados = categoria.Id === 4
        ? ordenarJuntaDirectivaPorJerarquia(repsCategoria)
        : repsCategoria;

      // ⭐ Agregar nueva página para cada categoría (excepto la primera)
      if (index > 0) {
        doc.addPage();
      }

      // Agregar header en cada nueva página
      let currentY = addPDFHeader(doc, asociacion.nombre_abreviado, categoria.Descripcion);

      // Título de sección
      currentY = addSectionTitle(doc, currentY + 10, categoria.Descripcion, repsOrdenados.length);

      const esDepartamental = categoria.Id === 3;

      const headers = esDepartamental 
        ? [['Nombre Completo', 'DNI', 'Departamento', 'Municipio']]
        : [['Nombre Completo', 'DNI', 'Cargo', 'Departamento', 'Municipio']];

      const tableData = repsOrdenados.map(rep => {
        const categoriaRep = rep.categorias?.find(cat => cat.Id === categoria.Id && cat.Estado !== 'Inactivo');
        const departamento = departamentos?.find(d => d.CodigoDepartamento === rep.cod_depto);
        const municipio = municipios?.find(m => String(m.CodigoMunicipio).trim() === String(rep.cod_municipio).trim());

        if (esDepartamental) {
          return [
            rep.nombre_representante || 'Sin nombre',
            rep.dni || 'Sin DNI',
            departamento?.NombreDepartamento || 'N/A',
            municipio?.NombreMunicipio || 'N/A'
          ];
        }

        return [
          rep.nombre_representante || 'Sin nombre',
          rep.dni || 'Sin DNI',
          categoriaRep?.Cargo || 'Sin cargo',
          departamento?.NombreDepartamento || 'N/A',
          municipio?.NombreMunicipio || 'N/A'
        ];
      });

      const columnStyles = esDepartamental 
        ? {
            0: { cellWidth: 'auto', fontStyle: 'bold' },
            1: { cellWidth: 25 },
            2: { cellWidth: 'auto' },
            3: { cellWidth: 'auto' }
          }
        : {
            0: { cellWidth: 'auto', fontStyle: 'bold' },
            1: { cellWidth: 25 },
            2: { cellWidth: 'auto' },
            3: { cellWidth: 'auto' },
            4: { cellWidth: 'auto' }
          };

      doc.autoTable({
        head: headers,
        body: tableData,
        startY: currentY,
        styles: {
          font: 'Helvetica',
          fontSize: 9,
          cellPadding: 4.5,
          textColor: [26, 26, 26],
          halign: 'left',
          lineColor: [232, 223, 214],
          lineWidth: 0.2
        },
        headStyles: {
          fillColor: [accentColor.r, accentColor.g, accentColor.b],
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          fontSize: 9,
          halign: 'left'
        },
        alternateRowStyles: {
          fillColor: [cardBg.r, cardBg.g, cardBg.b]
        },
        margin: {
          left: PDF_CONFIG.margins.left,
          right: PDF_CONFIG.margins.right
        },
        columnStyles: columnStyles,
        didDrawPage: (data) => {
          // Agregar footer en cada página de la tabla
          addPDFFooter(doc);
        }
      });
    });

    // Agregar footer a todas las páginas finales
    const pageCount = doc.internal.getNumberOfPages();
    for (let i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      addPDFFooter(doc);
    }

    doc.save(`Reporte_Completo_${asociacion.nombre_abreviado}_${new Date().toISOString().split('T')[0]}.pdf`);
  } catch (error) {
    console.error('Error en exportAsociacionCategoriasPDF:', error);
    throw error;
  }
};
